import { Alert } from "@mui/material";

export default function FallbackAlert({ error }: { error: any }) {
  return <Alert severity="error">{error.message}</Alert>;
}
